<!-- 
    FORM VISUALIZACAO DA PESSOA DE CONTATO
-->

<script>
import Vue from 'vue';
import { apiORDSpost, apiORDSdelete, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { SysVars } from '../main';
import apiCrm from '../api/api-crm.js'

import CrmPipeline from './crm-pipeline'
import AnexosForm from '../components/anexos-form'
import CrmNegocioNovoForm from './crm-negocio-novo-form'
import CrmOrgNovoForm from './crm-org-novo-form'
import CrmPessoaNovoForm from './crm-pessoa-novo-form'
import CrmNegocioParticipantes from './crm-negocio-participantes'
import CrmNegocioSeguidores from './crm-negocio-seguidores'
import CrmNegocioAgenda from './crm-negocio-agenda'
import CrmEmail from './crm-email'
import CrmNotes from './crm-notes'
import CrmCard from './crm-card'

export default {
    props: {
        index: '',
    },
    
    components: {
        AnexosForm, CrmPipeline, CrmNegocioNovoForm, CrmOrgNovoForm, 
        CrmEmail, CrmPessoaNovoForm, CrmNegocioParticipantes, CrmNegocioSeguidores, CrmNegocioAgenda,
        CrmCard, CrmNotes
    },

    data () {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormOrg: false,
            showFormPessoa: false,

            pessoa: null,

            paramsNegocio: null,
            paramsPessoa: null,

            anexos: [], //lista de anexos
            notes: [],
            addingNote: false,

            seguidores: [],
            showFormSeguidores: false,

            indexNote: null,
            texto: null,

            tabs: [
                { title: 'Detalhes', help: null, icon: 'fa-paperclip', count: 0 },
                { title: 'Arquivos', help: null, icon: 'fa-paperclip', count: 0 },
                // { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 },
                { title: 'Atividades Concluídas', help: null, icon: 'fa-calendar', count: 0 },
                { title: 'Negócios', help: null, icon: 'fa-dollar', count: 0 },
                { title: 'Negócios Vinculados', help: null, icon: 'fa-chain', count: 0 },
            ],

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function () {
            return this.pessoa.excluido!='S'
        },

        tabDetalhes: function () {
            return this.activeTab=='0'
        },

        tabAnexos: function () {
            return this.activeTab=='1'
        },

        tabAgenda: function () {
            return this.activeTab=='2'
        },

        tabNegocios: function () {
            return this.activeTab=='3'
        },

        tabNegociosVinculados: function () {
            return this.activeTab=='4'
        },

        nomeUsuario: function () {
            if (this.pessoa && this.pessoa.usuario.length > 0)
              return this.pessoa.usuario[0].nome
            else 
              return null
        },

        organizacao: function () {
            if (this.pessoa && this.pessoa.organizacao.length > 0)
              return this.pessoa.organizacao[0]
            else 
              return null
        },

        tag: function () {
            if (this.pessoa && this.pessoa.tag.length > 0)
              return this.pessoa.tag[0]
            else 
              return null
        },

        agendaList: function () {
            return this.pessoa.agenda.filter((obj) => {
                return obj.concluida === 'S'
            })
        },

        agendaListPlanejada: function () {
            return this.pessoa.agenda.filter((obj) => {
                return obj.concluida != 'S'
            })
        },

        listNegocios: function () {
            if (this.pessoa.negocios)
                return this.pessoa.negocios
            else 
                return []
        },

        listVinculados: function () {
            if (this.pessoa.negocios)
                return this.pessoa.negocios_vinculados
            else 
                return []
        },

        emailList: function () {
            this.tabs[3].count = this.$store.getters.getNegocioEmails.length
            return this.$store.getters.getNegocioEmails
        },

    },

    methods: {
        changeTab (idx) {
            this.activeTab = idx
        },

        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },

        closeFormOrg (organizacao) {
            this.showFormOrg = false
            if (this.organizacao) {
                this.loadData()
            }
        },

        handleExcluir () {
            if (confirm("Confirma a exclusão?")) {
                this.apiPessoasDelete(this.pessoa.codpessoa, this.callBackPessoa)
            }
        },

        handleReabrir () {
            let obj = { codpessoa: this.pessoa.codpessoa, excluido: 'N' }
            this.apiPessoas(obj, this.pessoa.codpessoa, this.callBackPessoa)
        },

        callBackPessoa (data) {
            if (data) {
                this.pessoa = data
                if (!this.pessoa.codorg)
                  this.organizacao = null
            }
        },

        closeForm () {
            if (this.$route.params.id)
                this.$router.go(-1)
            else
                this.$emit('closeform')
        },

        loadEmails () {
            this.showCodemail = null
            this.$store.dispatch('loadNegocioEmails', { id: this.pessoa.codnegocio } )
        },

        async loadData () {
            await this.$store.dispatch('loadConfigCrm', this)
            let codpessoa = this.index
            if (this.$route.params && this.$route.params.id)
              codpessoa = this.$route.params.id
            await this.$store.dispatch('loadPessoa', { id: codpessoa } )
            if (this.$store.getters.getPessoa) {
                this.pessoa = {...this.$store.getters.getPessoa}
                console.log(this.pessoa.tag)
                console.log(this.organizacao.tag)
                this.notes = this.pessoa.notes
                this.seguidores = this.pessoa.seguidores
                this.anexos = this.pessoa.anexos
            }

            //CONTADORES
            // this.tabs[1].count = this.anexos.length
            // this.tabs[2].count = this.emailList.length
            // this.tabs[2].count = this.agendaList.length
            // this.tabs[3].count = this.listNegocios.length
            // this.tabs[4].count = this.listVinculados.length
        },

        handleEditarPessoa (tipo) {
            this.paramsPessoa = {}
            if (tipo == 'org')
              this.paramsPessoa.org = true
            else
            if (tipo == 'fone')
              this.paramsPessoa.fone = true
            else
            if (tipo == 'email')
              this.paramsPessoa.email = true
            else
              this.paramsPessoa = null
            this.showFormPessoa = true
        },

        closeFormPessoa (pessoa) {
            this.showFormPessoa = false
            if (pessoa)
              this.pessoa = pessoa
        },


        //////////////////////////// ALTERAR OU VISUALIZAR NEGOCIO
        handleShowNegocio (codnegocio) {
          this.$router.push('/crm/negocio/' + codnegocio)
        },

        handleIncluirNegocio () {
            this.paramsNegocio = { pessoa: this.pessoa, organizacao: this.organizacao }
            this.showFormNegocio = true;
        },

        closeNovoNegocio (negocio) {
            this.showFormNegocio = false
            if (negocio)
              this.handleShowNegocio(negocio.codnegocio)
        },

        /////////////////////////////////// ORGANIZACAO
        handleDesvincularOrg () {
            let obj = { codpessoa: this.pessoa.codpessoa, codorg: null }
            this.apiPessoas(obj, this.pessoa.codpessoa, this.callBackPessoa)
        },

        handleShowOrg () {
          this.$router.push('/crm/organizacao/' + this.pessoa.codorg)
        },

        handleEditarOrg () {
            this.showFormOrg = true
        },

        closeFormOrg () {
            this.showFormOrg = false
        },


        /////////////////////////////////// SEGUIDORES
        handleIncluirSeguidor () {
            this.showFormSeguidores = true
        },
        handleCloseSeguidor () {
            this.seguidores = this.pessoa.seguidores
            this.showFormSeguidores = false
        },
        /////////////////////////////////// FIM SEGUIDORES



        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda (codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda()
        },
        updateAgenda (agenda) {
            this.tabs[3].count = this.agendaList.length
        },
        /////////////////////////////////// FIM ATIVIDADES




        /////////////////////////////////// ANEXOS
        handleAnexarDocumento() {
            //ANEXAR DOCUMENTOS
            this.$nextTick(function () {
                this.$refs.anexos.handleClickAdiciona()
            })
        },
        handleChangeAnexos(anexosList) {
            //ATUALIZA A LISTA DE ANEXOS
            this.anexos = anexosList
            this.tabs[1].count = this.anexos.length
        },
        /////////////////////////////////// FIM ANEXOS



    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
               this.$refs.usuario.focus()
            }
        })
    },

    created () {
        this.loadData()
    }

}

</script>

<template>

<div id="formorg" class="deal-form" v-if="pessoa">
    <div class="deal-form-1">
        <div class="deal-form-2">
            <div class="deal-form-3">
                <div class="deal-form-left">
                    <div class="row">
                        <!-- NOME DA PESSOA -->
                        <div class="col-12 mt-2">
                            <span class="lbl-deal-title" style="cursor: pointer" @click="handleEditarPessoa">{{ pessoa.nome}}</span>
                            <span v-if="pessoa.excluido=='S'" class="badge badge-red">Excluída</span>
                            <v-button v-if="pessoa.excluido!='S'" class="float-right" label="" title="Excluir este contato" :danger="true" icon="fa-trash" @click="handleExcluir"></v-button>
                            <v-button v-if="pessoa.excluido!='S'" class="float-right" label="" title="" icon="fa-pencil" @click="handleEditarPessoa"></v-button>
                            <v-button v-if="pessoa.excluido=='S'" class="float-right" label="Reabrir" title="Reabrir este contato" icon="" @click="handleReabrir"></v-button>
                        </div>
                        <div class="col-12">
                            <div class="w-100">
                                <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ pessoa.data | formatDataHoraExtenso }}</span>
                            </div>
                            <div class="w-100">
                                <span class="lbl-list" v-for="(fone, index) in pessoa.telefones" :key="index"><i class="fa fa-phone pr-2" aria-hidden="true"></i> {{ fone.numero | formatFone }} </span>
                            </div>
                            <div class="w-100">
                                <span class="lbl-list" v-for="(email, index) in pessoa.emails" :key="index"><i class="fa fa-envelope pr-2" aria-hidden="true"></i> {{ email.email }} </span>
                            </div>
                        </div>
                        <!-- ETIQUETA -->
                        <div class="col-12 mt-3" v-if="permiteAlteracao">
                            <div v-if="pessoa.tag.length>0">
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span class="tag-input-color" :style="handleStyle(pessoa.tag[0].cor)" @click="handleEditarPessoa">{{ pessoa.tag[0].descricao }} </span>
                            </div>
                            <v-button v-else :link="true" label="Definir uma etiqueta" icon="fa-tag" @click="handleEditarPessoa"></v-button>
                        </div>
                        <!-- ORGNIZACAO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">ORGANIZAÇÃO</span>
                            </div>
                            <div v-if="pessoa.codorg" class="w-100">
                                <i class="fa fa-university pr-2" aria-hidden="true" style="font-size: 18px"></i>
                                <span class="lbl-subtitle pr-2"> {{ organizacao.nome }} </span>
                                <span v-if="organizacao.tag.length>0" class="tag-input-color" :style="handleStyle(organizacao.tag[0].cor)"><i class="fa fa-tag pr-2" aria-hidden="true" style="font-size: 18px"></i> {{ organizacao.tag[0].descricao }} </span>
                                <span class="fa fa-pencil pl-3" data-toggle="dropdown"></span>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item pr-3" @click="handleDesvincularOrg"><i class="fa fa-chain-broken pr-2" aria-hidden="true"></i> Desvincular esta organização</a>
                                    <a class="dropdown-item pr-3" @click="handleEditarPessoa('org')"><i class="fa fa-exchange pr-2" aria-hidden="true"></i> Trocar organização</a>
                                    <a class="dropdown-item pr-3" @click="handleEditarOrg"><i class="fa fa-pencil pr-2" aria-hidden="true"></i> Alterar dados desta organização</a>
                                    <a class="dropdown-item pr-3" @click="handleShowOrg"><i class="fa fa-search pr-2" aria-hidden="true"></i> Exibir organização</a>
                                </div>
                                <div class="w-100"></div>
                                <span class="lbl-list"> {{ organizacao.cnpj | formatCNPJCPF }} </span>
                            </div>
                            <div v-if="!pessoa.codorg && permiteAlteracao" class="w-100">
                                <i class="fa fa-university pr-2" aria-hidden="true" style="font-size: 18px"></i>
                                <a class="pr-3" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocioOrg"> Vincular uma organização </a>
                            </div>
                        </div>
                        <!-- PROPRIETARIO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle mb-2">PROPRIETÁRIO</span>
                            </div>
                            <div>
                                <a class="lbl pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ nomeUsuario }}</a>
                            </div>
                        </div>
                        <!-- SEGUIDORES -->
                        <div class="col-12 mt-5">
                            <span class="lbl-deal-subtitle">USUÁRIOS VINCULADOS</span>
                            <v-button v-if="permiteAlteracao" :link="true" label="Adicione usuários vinculados" icon="fa-plus" :nb-btdef="false" @click="handleIncluirSeguidor"></v-button>
                            <span v-for="(item, index) in seguidores" :key="index">
                                    <a class="data-list pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</a>
                            </span>
                        </div>

                        <div class="col-12 mt-5">
                            <span class="lbl-deal-subtitle"><i class="fa fa-paperclip pr-2"></i>ANEXOS</span>
                            <v-button v-if="permiteAlteracao" :link="true" label="Anexar um Arquivo" icon="fa-plus" :nb-btdef="false" @click="handleAnexarDocumento"></v-button>
                            <div class="mt-3">
                                <anexos-form ref="anexos" :params="{ ref: 'pessoacrm', chaveref: pessoa.codpessoa, showForm: false }" @change="handleChangeAnexos"></anexos-form>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="deal-form-right">
                    <div class="sticky">
                        <button type="button" class="close" style="" @click="closeForm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div style="overflow-x: auto; height: 100%;">
                        <div class="mt-1">
                            <crm-notes :params="{ codpessoa: pessoa.codpessoa, notes: notes }"></crm-notes>
                        </div>
                        <div class="mt-5">
                            <span class="lbl-deal-subtitle mb-2"><i class="fa fa-calendar pr-2"></i>ATIVIDADES PLANEJADAS</span>
                            <v-button :link="true" label="Criar uma atividade" icon="fa-plus" @click="handleIncluirAgenda"></v-button>
                        </div>
                        <crm-negocio-agenda ref="agenda" 
                            :params="{ organizacao: organizacao, pessoa: pessoa, listAgenda: pessoa.agenda, listAgendaShow: agendaListPlanejada, delete: true, edit: true }"
                            @update="updateAgenda" @delete="updateAgenda"></crm-negocio-agenda>
                        <div class="mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle"><i class="fa fa-dollar pr-2"></i>NEGÓCIOS</span>
                            </div>
                        </div>
                        <div v-for="(negocio, index) in listNegocios" :key="index">
                            <crm-card :negocio="negocio" @edit="handleShowNegocio(negocio.codnegocio)"></crm-card>
                        </div>
                        <div class="mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle"><i class="fa fa-dollar pr-2"></i>NEGÓCIOS VINCULADOS</span>
                            </div>
                        </div>
                        <div v-for="(negocio, index) in listVinculados" :key="index">
                            <crm-card :negocio="negocio" @edit="handleShowNegocio(negocio.codnegocio)"></crm-card>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <crm-negocio-novo-form v-if="showFormNegocio" :params="paramsNegocio" @closeform="closeNovoNegocio"></crm-negocio-novo-form>
    <crm-pessoa-novo-form v-if="showFormPessoa" :index="pessoa.codpessoa" :params="paramsPessoa" @closeform="closeFormPessoa"></crm-pessoa-novo-form>
    <crm-org-novo-form v-if="showFormOrg" :index="organizacao.codorg" @closeform="closeFormOrg"></crm-org-novo-form>
    <crm-negocio-seguidores v-if="showFormSeguidores" :params="{ pessoa: pessoa }" @closeform="handleCloseSeguidor"></crm-negocio-seguidores>

</div>





</template>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-pessoa-form.vue